<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">
              <b>Subgrupos do Contrato</b>
            </h3>

            <router-link
              tag="a"
              class="btn btn-primary pull-right"
              :to="`/distribuicoes/contratos/subgrupos/novo/${$route.params.contrato_id}`"
            >
              <i class="fa fa-plus"></i> Adicionar Subgrupo
            </router-link>
          </div>

          <div class="box-body">
            <cabecario-contrato :contratoId="$route.params.contrato_id"></cabecario-contrato>
            <filtro-contrato-subgrupo
              @filtrar="
                                filtros => {
                                    filtrar(filtros);
                                }
                            "
            ></filtro-contrato-subgrupo>

            <div class="row" style="margin-top:15px">
              <div class="col-sm-12 table-responsive">
                <table
                  aria-describedby="example1_info"
                  role="grid"
                  id="example1"
                  class="table table-bordered table-striped"
                >
                  <thead>
                    <tr role="row">
                      <th style="width: 10%;">Controle</th>
                      <th style="width: 10%;">Código</th>
                      <th style="width: 45%;">Subgrupo</th>
                      <th style="width: 34%;">Limite Financeiro</th>
                      <th style="width: 1%">Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="even" role="row" v-for="item in dataTable.data" :key="item.id">
                      <td>{{ item.id }}</td>
                      <td>{{ item.subgrupo.codigo }}</td>
                      <td>{{ item.subgrupo.nome }}</td>
                      <td>
                          <table class="table table-bordered table-hover table-striped">
                            <thead>
                              <tr role="row">
                                <th style="width: 34%">M</th>
                                <th style="width: 33%">D</th>
                                <th style="width: 33%">C</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr class="even" role="row">
                                <td
                                  title="Limite Distribuído (Modelo)"
                                  style="background-color: blue; color: white"
                                >{{ item.limite.valor_original | numberFormat(2, ",", ".") }}</td>
                                <td
                                  title="Limite Disponível"
                                  style="background-color: green; color: white"
                                ><strong>{{ item.limite.valor | numberFormat(2, ",", ".") }}</strong></td>
                                <td
                                  title="Limite Consumido"
                                  style="background-color: #ffdb58; color: black"
                                ><strong>{{ item.limite_consumido | numberFormat(2, ",", ".") }}</strong></td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      <td>
                        <router-link
                          tag="button"
                          class="btn btn-warning btn-sm"
                          :to="`/distribuicoes/contratos/subgrupos/atualizacao/${item.id}`"
                          title=" Editar"
                        >
                          <i style="font-size:12px" class="fa fa-fw fa-edit"></i>
                        </router-link>
                        <!--
                                          <button  class="btn btn-danger btn-sm"  title="Excluir" @click="deletar(item)">
                                            <i style="font-size:12px" class="fa fa-fw fa-close"></i>
                        </button>-->
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="row">
                  <div
                    class="col-sm-5"
                  >Mostrando {{ this.dataTable.from }} até {{ this.dataTable.to }} de {{ this.dataTable.total }} registros encontrados.</div>

                  <div class="col-sm-7" style="text-align:right">
                    <laravue-pagination
                      :limit="5"
                      :data="dataTable"
                      v-on:pagination-change-page="getDataTable"
                    >
                      <span slot="prev-nav">&lt; Anterior</span>
                      <span slot="next-nav">Próximo &gt;</span>
                    </laravue-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="box-footer">
            <div class="row">
              <div class="col-md-12">
                <button class="btn btn-default pull-left" @click="$router.go(-1)">
                  <i class="fa fa-reply"></i> Voltar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from "axios"; // Cliente para requisição http
import Alert from "../../Alert"; // Importando componente alert
import CabecarioContrato from "./cabecarioContrato";
import FiltroContratoSubgrupo from "./filtroContratoSubgrupo";

export default {
  filters: {},
  data: () => ({
    filtros: {
      distribuicao_contrato_id: null
    },

    dataTable: {}
  }),

  mounted() {
    this.filtros.distribuicao_contrato_id = this.$route.params.contrato_id;
    this.getDataTable();
  },

  methods: {
    sortByKey: function(field) {
      this.dados.coluna = field;
      if (this.dados.ordem == "asc") {
        this.dados.ordem = "desc";
      } else {
        this.dados.ordem = "asc";
      }
      // this.geDataTable();
    },

    filtrar: function(filtros) {
      this.filtros = { ...this.filtros, ...filtros };
      this.getDataTable();
    },

    getDataTable(page) {
      if (typeof page === "undefined") {
        page = 1;
      }

      this.filtros.page = page;
      this.$store.commit("TOGGLE_LOADING");

      let config = this.$store.getters.getHeaderAuth;
      config.params = this.filtros;

      axios
        .get(
          `${this.$store.state.serverURI}/api/distribuicao/contratos/getContratoSubgruposPaginate`,
          config
        )
        .then(response => {
          this.dataTable = response.data;
          this.$store.commit("TOGGLE_LOADING");
        })
        .catch(error => {
          this.$store.commit("throwException", error);
        });
    },

    deletar(item, index) {
      this.$swal({
        title: `Confirma exclusão do subgrupo ${item.subgrupo.nome}?`,
        text: `Todos os procedimentos do contrato vinculado a esse subgrupo serão excluídos`,
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
        cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
        reverseButtons: true
      }).then(result => {
        if (result.value) {
          this.$swal({
            title: "Aguarde...",
            imageUrl: "/static/img/Rolling-green.gif",
            showConfirmButton: false,
            allowOutsideClick: false
          });
          axios
            .delete(
              `${this.$store.state.serverURI}/api/distribuicao/contratos/deleteContratoSubgrupo/${item.id}`,
              this.$store.getters.getHeaderAuth
            )
            .then(response => {
              this.getDataTable();
              this.$swal({
                type: "success",
                title: "Subgrupo excluído com sucesso!",
                showConfirmButton: false,
                timer: 1500
              });
            })
            .catch(error => {
              console.log(error);
            });
        }
      });
    }
  },
//   watch: {
//     page: function(val) {
//       this.getDataTable();
//     }
//   },

  components: {
    Alert,
    CabecarioContrato,
    FiltroContratoSubgrupo
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// contratoSubgrupo.vue?9344d316